import type { CookieOption } from 'next-auth';
export const COOKIES_LOOKUP = {
    /**
     * This is set in our ./server/server.ts setup.
     */
    SESSION_GUID: 'zguid',
};

export const TIME_UNITS = {
    SECONDS_TO_MILLISECONDS: 1000,
    ONE_SECOND: 1,
    ONE_SECOND_IN_MS: 1000,
    MINUTES_TO_MINUTES_IN_SECONDS: 60,
};

const ACCESS_TOKEN_TTL_IN_MINUTES = 30;
export const ACCESS_TOKEN_TTL = {
    IN_MINUTES: ACCESS_TOKEN_TTL_IN_MINUTES,
    IN_SECONDS: ACCESS_TOKEN_TTL_IN_MINUTES * TIME_UNITS.MINUTES_TO_MINUTES_IN_SECONDS,
    IN_MILLISECONDS:
        ACCESS_TOKEN_TTL_IN_MINUTES * TIME_UNITS.MINUTES_TO_MINUTES_IN_SECONDS * TIME_UNITS.SECONDS_TO_MILLISECONDS,
};

const SHORT_ACCESS_TOKEN_TTL_IN_MINUTES = 3;
export const SHORT_ACCESS_TOKEN_TTL = {
    IN_MINUTES: SHORT_ACCESS_TOKEN_TTL_IN_MINUTES,
    IN_SECONDS: SHORT_ACCESS_TOKEN_TTL_IN_MINUTES * TIME_UNITS.MINUTES_TO_MINUTES_IN_SECONDS,
    IN_MILLISECONDS:
        SHORT_ACCESS_TOKEN_TTL_IN_MINUTES *
        TIME_UNITS.MINUTES_TO_MINUTES_IN_SECONDS *
        TIME_UNITS.SECONDS_TO_MILLISECONDS,
};

const REFRESH_TOKEN_TTL_IN_MINUTES = 45;
export const REFRESH_TOKEN_TTL = {
    IN_MINUTES: REFRESH_TOKEN_TTL_IN_MINUTES,
    IN_SECONDS: REFRESH_TOKEN_TTL_IN_MINUTES * TIME_UNITS.MINUTES_TO_MINUTES_IN_SECONDS,
    IN_MILLISECONDS:
        REFRESH_TOKEN_TTL_IN_MINUTES * TIME_UNITS.MINUTES_TO_MINUTES_IN_SECONDS * TIME_UNITS.SECONDS_TO_MILLISECONDS,
};

const SHORT_REFRESH_TOKEN_TTL_IN_MINUTES = 4;
export const SHORT_REFRESH_TOKEN_TTL = {
    IN_MINUTES: SHORT_REFRESH_TOKEN_TTL_IN_MINUTES,
    IN_SECONDS: SHORT_REFRESH_TOKEN_TTL_IN_MINUTES * TIME_UNITS.MINUTES_TO_MINUTES_IN_SECONDS,
    IN_MILLISECONDS:
        SHORT_REFRESH_TOKEN_TTL_IN_MINUTES *
        TIME_UNITS.MINUTES_TO_MINUTES_IN_SECONDS *
        TIME_UNITS.SECONDS_TO_MILLISECONDS,
};

export enum ZILLOW_AUTH_PROVIDER {
    ZILLOW_AUTH = 'zillow-oauth',
    SHORT_ZILLOW_AUTH = 'zillow-oauth-short',
    AUTH0 = 'zillow-auth0',
}
export enum SessionStatus {
    AUTHENTICATED = 'authenticated',
    LOADING = 'loading',
    UNAUTHENTICATED = 'unauthenticated',
}

/**
 * Pulled directly from https://github.com/nextauthjs/next-auth/blob/main/packages/core/src/lib/utils/cookie.ts#L62
 * with useSecureCookies set to true.
 */
export const DEFAULT_COOKIE_OPTIONS: Record<
    'SESSION_TOKEN' | 'CALLBACK_URL' | 'CSRF_TOKEN' | 'PKCE_CODE_VERIFIER' | 'STATE' | 'NONCE',
    CookieOption['options']
> = {
    SESSION_TOKEN: {
        httpOnly: true,
        sameSite: 'lax',
        path: '/',
        secure: true,
    },
    CALLBACK_URL: {
        httpOnly: true,
        sameSite: 'lax',
        path: '/',
        secure: true,
    },
    CSRF_TOKEN: {
        httpOnly: true,
        sameSite: 'lax',
        path: '/',
        secure: true,
    },
    PKCE_CODE_VERIFIER: {
        httpOnly: true,
        sameSite: 'lax',
        path: '/',
        secure: true,
        maxAge: 60 * 15, // 15 minutes in seconds
    },
    STATE: {
        httpOnly: true,
        sameSite: 'lax',
        path: '/',
        secure: true,
        maxAge: 60 * 15, // 15 minutes in seconds
    },
    NONCE: {
        httpOnly: true,
        sameSite: 'lax',
        path: '/',
        secure: true,
    },
};
